import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useFetch from "../hooks/useFetch";
import config from "../config";
import "./Navbar.css";

const Navbar = () => {
  //fetch loga - ignore pro loading a error, ktere nepouzivame
  // eslint-disable-next-line
  const { loading, error, data } = useFetch(
    `${config.api}/api/navbar?populate=*`
  );
  useEffect(() => {
    const navEl = document.querySelector(".navbar");
    const togglerButton = document.getElementById("togglerButton");

    const handleScroll = () => {
      if (window.scrollY > 56) {
        navEl.classList.add("navbar-scrolled");
      } else if (
        window.scrollY < 56 &&
        togglerButton.classList.contains("collapsed")
      ) {
        navEl.classList.remove("navbar-scrolled");
      }
    };

    const handleToggle = () => {
      if (navEl.classList.contains("navbar-scrolled") && window.scrollY < 56) {
        navEl.classList.remove("navbar-scrolled");
      } else {
        navEl.classList.add("navbar-scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    togglerButton.addEventListener("click", handleToggle);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      togglerButton.removeEventListener("click", handleToggle);
    };
  }, []);

  function changeFavicon(url) {
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  // Call the function and pass the favicon URL
  changeFavicon(`${config.api}${data?.data?.favicon?.url}`);

  return (
    <nav className="navbar fixed-top navbar-expand-xl navbar-light navbar-background">
      <div className="container">
        <a className="navbar-brand d-block d-xl-none" href="/">
          <img
            src={`${config.api}${data?.data?.logo?.url}`}
            alt={data?.data?.logo?.alternativeText}
            className="nav-big-logo"
          />
        </a>
        <div className="d-flex align-items-center">
          <button
            id="togglerButton"
            className="navbar-toggler me-3 collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#polozky"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>

        <div className="collapse navbar-collapse" id="polozky">
          <ul className="navbar-nav me-auto">
            <a className="navbar-brand d-none d-xl-block" href="/">
              <img
                src={`${config.api}${data?.data?.logo?.url}`}
                alt={data?.data?.logo?.alternativeText}
                className="nav-big-logo"
              />
            </a>
          </ul>
          <div>
            <ul className="navbar-nav">
              <li className="nav-item position-relative">
                <a
                  className="nav-link btn m-1 p-2 main-menu-item nav-text"
                  href="/aktuality"
                >
                  AKTUALITY
                </a>
              </li>

              <li className="nav-item dropdown position-relative">
                <a
                  className="nav-link dropdown-toggle btn m-1 p-2 main-menu-item nav-text"
                  href="/about"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  ŠKOLA
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="m-1 mb-2"
                    shapeRendering="geometricPrecision"
                    textRendering="geometricPrecision"
                    imageRendering="optimizeQuality"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    viewBox="0 0 319 511.61"
                  >
                    <path d="M48.92 505.72 5.88 462.68c-7.85-7.85-7.83-20.72 0-28.54l178.35-178.35L5.88 77.44c-7.85-7.85-7.8-20.73 0-28.54L48.92 5.87c7.83-7.82 20.71-7.82 28.54 0l192.25 192.26.37.36 43.04 43.03c7.82 7.84 7.86 20.69 0 28.54l-43.04 43.04-.37.36L77.46 505.72c-7.85 7.86-20.68 7.86-28.54 0z" />
                  </svg>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="/historie">
                      Historie
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/udalosti">
                      Projekty
                    </a>
                  </li>
                  <li>
                    <Link
                      to={`/povinne-zverejnovane-informace`}
                      className="dropdown-item"
                    >
                      Povinně zveřejňované informace
                    </Link>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/ochrana-osobnich-udaju">
                      Ochrana osobních údajů
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/prevence">
                      Prevence
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/sponzori">
                      Partneři
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/jidelna">
                      Jídelna
                    </a>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown position-relative">
                <a
                  className="nav-link dropdown-toggle btn m-1 p-2 main-menu-item nav-text"
                  href="/about"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  VÝUKA
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="m-1 mb-2"
                    shapeRendering="geometricPrecision"
                    textRendering="geometricPrecision"
                    imageRendering="optimizeQuality"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    viewBox="0 0 319 511.61"
                  >
                    <path d="M48.92 505.72 5.88 462.68c-7.85-7.85-7.83-20.72 0-28.54l178.35-178.35L5.88 77.44c-7.85-7.85-7.8-20.73 0-28.54L48.92 5.87c7.83-7.82 20.71-7.82 28.54 0l192.25 192.26.37.36 43.04 43.03c7.82 7.84 7.86 20.69 0 28.54l-43.04 43.04-.37.36L77.46 505.72c-7.85 7.86-20.68 7.86-28.54 0z" />
                  </svg>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to={`/zakladni-skola`} className="dropdown-item">
                      Základní škola
                    </Link>
                  </li>
                  <li>
                    <Link to={`/skolni-druzina`} className="dropdown-item">
                      Školní družina
                    </Link>
                  </li>
                  <li>
                    <Link to={`/tridy`} className="dropdown-item">
                      Třídy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/organizace-skolniho-roku`}
                      className="dropdown-item"
                    >
                      Organizace školního roku
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/zapis-do-prvni-tridy`}
                      className="dropdown-item"
                    >
                      Zápis do první třídy
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item position-relative">
                <a
                  className="nav-link btn m-1 p-2 main-menu-item nav-text"
                  href="/dokumenty"
                >
                  DOKUMENTY
                </a>
              </li>
              <li className="nav-item position-relative">
                <a
                  className="nav-link btn m-1 p-2 main-menu-item nav-text"
                  href="/fotogalerie"
                >
                  FOTOGALERIE
                </a>
              </li>
              <li className="nav-item dropdown position-relative">
                <a
                  className="nav-link dropdown-toggle btn m-1 p-2 main-menu-item nav-text"
                  href="/about"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  KONTAKTY
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="m-1 mb-2"
                    shapeRendering="geometricPrecision"
                    textRendering="geometricPrecision"
                    imageRendering="optimizeQuality"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    viewBox="0 0 319 511.61"
                  >
                    <path d="M48.92 505.72 5.88 462.68c-7.85-7.85-7.83-20.72 0-28.54l178.35-178.35L5.88 77.44c-7.85-7.85-7.8-20.73 0-28.54L48.92 5.87c7.83-7.82 20.71-7.82 28.54 0l192.25 192.26.37.36 43.04 43.03c7.82 7.84 7.86 20.69 0 28.54l-43.04 43.04-.37.36L77.46 505.72c-7.85 7.86-20.68 7.86-28.54 0z" />
                  </svg>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to={`/kontakt`} className="dropdown-item">
                      Vedení
                    </Link>
                  </li>
                  <li>
                    <Link to={`/zamestnanci`} className="dropdown-item">
                      Zaměstnanci
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
